import React from 'react';
import { Link } from 'react-router-dom';
import './FreePageHeader.css';

export default function FreePageHeader() {
  return (
    <header className="free-header">
      <div className="free-header__inner">
        <Link to="/free" className="free-header__logo">
          <img src="/robot.png" alt="Marketing Pro" className="free-header__logo-img" />
          <span className="free-header__logo-text">Marketing Pro</span>
        </Link>

        <nav className="free-header__actions">
          <Link to="/login" className="free-header__btn free-header__btn--ghost">
            Entrar
          </Link>
          <Link to="/signup" className="free-header__btn free-header__btn--primary">
            Criar conta gratis
          </Link>
        </nav>
      </div>
    </header>
  );
}
